var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._b({
    attrs: {
      "icon": "",
      "disabled": !_vm.project,
      "loading": _vm.downloadStatus.pending || _vm.addNotificationStatus.pending
    },
    on: {
      "click": _vm.download
    }
  }, 'v-btn', _vm.$attrs, false), [_c('snackbar', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: _vm.downloadStatus.pending,
      callback: function ($$v) {
        _vm.$set(_vm.downloadStatus, "pending", $$v);
      },
      expression: "downloadStatus.pending"
    }
  }, [_vm._v("Downloading…")]), _c('error-dialog', {
    attrs: {
      "status": _vm.downloadStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.addNotificationStatus
    }
  }), _c('sign-in-dialog', {
    ref: "sign-in",
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("Verify your email address")];
      },
      proxy: true
    }, {
      key: "subtitle",
      fn: function () {
        return [_vm._v("We'll send you an email when this project is ready to download / share")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), _vm.showNotReady ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.showNotReady,
      callback: function ($$v) {
        _vm.showNotReady = $$v;
      },
      expression: "showNotReady"
    }
  }, [_c('v-card', {
    staticClass: "overflow-x-hidden"
  }, [_c('v-btn', {
    staticClass: "float-right ma-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showNotReady = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Download not ready")]), _c('v-divider'), _vm.project.locked ? _c('div', {
    staticClass: "pa-6"
  }, [_c('p', [_vm._v("We're still building a video file that you can download / share for this project.")]), _c('div', {
    staticClass: "mb-5 d-flex align-baseline"
  }, [_c('div', {
    staticClass: "grey--text overline short mr-2"
  }, [_vm._v("Started")]), _c('div', {
    staticStyle: {
      "word-wrap": "normal"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.project.render.started_at)))])]), _vm.willNotify ? _c('div', [_vm._v("We will email you when it's ready.")]) : _c('div', [_vm._v("Do you want us to notify you when it's ready?")])]) : _vm.purchaseDialog ? _c('div', {
    staticClass: "pa-6"
  }, [_vm._v(" You'll be able to download this video after you check out and lock the project. See our "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://ellacard.com/faq#can-i-download-my-video"
    }
  }, [_vm._v("FAQ")]), _vm._v(" for more details. ")]) : _c('div', {
    staticClass: "pa-6"
  }, [_vm._v(" This video project has not been locked – we can't build a video file that you can download / share until " + _vm._s(_vm.globalUserId == _vm.project.user_id ? 'you lock' : 'the organizer locks') + " the project. See our "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://ellacard.com/faq#group-video-lock"
    }
  }, [_vm._v("FAQ")]), _vm._v(" for more details. ")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _vm.project.locked && !_vm.willNotify ? [_c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.showNotReady = false;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.addNotificationStatus.pending
    },
    on: {
      "click": _vm.addNotification
    }
  }, [_vm._v("Yes")])] : _c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.showNotReady = false;
      }
    }
  }, [_vm._v("Close")])], 2)], 1)], 1) : _vm._e(), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDownload)
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }